import baseAPI from '@/http'

const router = 'api/salaindicadoresmunicipios'
const routerExcel = 'api/arquivo/excel/download-indicadores-municipios'

export const SalaIndicadoresMunicipioAPI = {
  create: (indicadoresmunicipio) => baseAPI.post(router + '/cadastrar-indicador-municipio', indicadoresmunicipio),
  update: (indicadoresmunicipio) => baseAPI.put(router + '/atualizar-indicador-municipio', indicadoresmunicipio),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  GerarExcel: (id) => baseAPI.post(`${routerExcel}/${id}`),
  list: () => baseAPI.get(router),
  getByUf: (uf) => baseAPI.get(`${router}/obter-por-uf/${uf}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listIndicadores: () => baseAPI.get('api/salaindicadores'),
  GetAllIndicadores: (salaindicadoresId) => baseAPI.get(`api/salaindicadores/sala-indicadores-por-id/${salaindicadoresId}`)
}
